function Checkdate(d) {
    return d instanceof Date && !isNaN(d);
}

export default Checkdate
